import React from "react";

function ListFilter() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
    >
      <path
        fill="#01d0de"
        d="M296.167 238.867h-80.333c-8.284 0-15-6.716-15-15V159.6c0-8.284 6.716-15 15-15h80.333c8.284 0 15 6.716 15 15v64.267c0 8.284-6.716 15-15 15z"
        data-original="#01d0de"
      ></path>
      <path
        fill="#13f8e7"
        d="M296.167 110.333h-80.333c-8.284 0-15-6.716-15-15V15c0-8.284 6.716-15 15-15h80.333c8.284 0 15 6.716 15 15v80.333c0 8.285-6.716 15-15 15z"
        data-original="#13f8e7"
      ></path>
      <path
        fill="#0c98d0"
        d="M311.167 223.867V159.6c0-8.284-6.716-15-15-15H256v94.267h40.167c8.284 0 15-6.716 15-15z"
        data-original="#0c98d0"
      ></path>
      <path
        fill="#01d0de"
        d="M311.167 95.333V15c0-8.284-6.716-15-15-15H256v110.333h40.167c8.284 0 15-6.715 15-15z"
        data-original="#01d0de"
      ></path>
      <path
        fill="#66b8f4"
        d="M288.133 385.6h-64.267c-8.284 0-15 6.716-15 15V497a15 15 0 0021.708 13.417l64.267-32.133a15 15 0 008.292-13.417V400.6c0-8.284-6.716-15-15-15z"
        data-original="#66b8f4"
      ></path>
      <path
        fill="#5086ee"
        d="M303.133 464.867V400.6c0-8.284-6.716-15-15-15H256v112.104l38.841-19.421a15 15 0 008.292-13.416z"
        data-original="#5086ee"
      ></path>
      <path
        fill="#13f8e7"
        d="M151.567 174.6H71.233c-8.284 0-15-6.716-15-15V79.267c0-8.284 6.716-15 15-15h80.333c8.284 0 15 6.716 15 15V159.6c.001 8.284-6.715 15-14.999 15z"
        data-original="#13f8e7"
      ></path>
      <path
        fill="#0c98d0"
        d="M440.767 174.6h-80.333c-8.284 0-15-6.716-15-15V79.267c0-8.284 6.716-15 15-15h80.333c8.284 0 15 6.716 15 15V159.6c0 8.284-6.716 15-15 15z"
        data-original="#0c98d0"
      ></path>
      <path
        fill="#5086ee"
        d="M414.458 282.393a15.001 15.001 0 00-13.858-9.26H111.4a15 15 0 00-10.606 25.607l108.073 108.073h94.267L411.207 298.74a15 15 0 003.251-16.347z"
        data-original="#5086ee"
      ></path>
      <path
        fill="#6152dd"
        d="M411.207 298.74a15.002 15.002 0 00-10.606-25.607H256v133.68h47.133z"
        data-original="#6152dd"
      ></path>
      <path
        fill="#66b8f4"
        d="M440.767 303.133H71.233c-8.284 0-15-6.716-15-15v-64.267c0-8.284 6.716-15 15-15h369.533c8.284 0 15 6.716 15 15v64.267c.001 8.284-6.715 15-14.999 15z"
        data-original="#66b8f4"
      ></path>
      <path
        fill="#5086ee"
        d="M455.767 288.133v-64.267c0-8.284-6.716-15-15-15H256v94.267h184.767c8.284 0 15-6.716 15-15z"
        data-original="#5086ee"
      ></path>
    </svg>
  );
}

export default ListFilter;